<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <button
                                class="btn btn-secondary"
                                @click="copyTable"
                            >
                                <i class="fas fa-copy"></i> Copy Table
                            </button>
                            <!-- Collapse Button -->
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Company:</span
                                        >
                                        <v-select
                                            v-model="company"
                                            class="form-control"
                                            type="text"
                                            label="name"
                                            :options="companies"
                                            :reduce="
                                                (companies) => companies.code
                                            "
                                            name="company"
                                            placeholder="Select Company"
                                            :value="
                                                (companies) => companies.code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Zone:</span
                                        >
                                        <v-select
                                            v-model="zone"
                                            type="text"
                                            label="name"
                                            :options="zones"
                                            :reduce="(zones) => zones.zone_code"
                                            placeholder="Select Zone"
                                            :value="(zones) => zones.zone_code"
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3" v-if="$gate.isMISAdmin()">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Branch:</span
                                        >
                                        <v-select
                                            v-model="branch"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="From Date"
                                            v-model="fromdate"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            placeholder="To Date"
                                            v-model="todate"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="getStats"
                                        >
                                            Generate
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-3">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!--                        <div class="row">-->
                            <!--                            -->
                            <!--                        </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            <div class="col-md-12">
                <div class="row" align="center">
                    <div class="col-lg-4 col-6">
                        <!-- small box -->
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>
                                    {{ receipttotal | dotNumbers }} ({{
                                        receiptcount
                                    }})
                                </h3>
                                <p>Total Receipts</p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-person-add"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-6">
                        <!-- small box -->
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>
                                    {{ saleordertotal | dotNumbers }} ({{
                                        saleordercount
                                    }})
                                </h3>
                                <p>Sale Order Value</p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-pie-graph"></i>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-4 col-6">
                        <!-- small box -->
                        <div class="small-box bg-danger">
                            <div class="inner">
                                <h3>
                                    {{ invoicetotal | dotNumbers }} ({{
                                        invoicecount
                                    }})
                                </h3>
                                <p>Invoice Value</p>
                            </div>
                            <div class="icon">
                                <i class="ion ion-bag"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <div class="col-lg-12">
                <div class="card card-danger card-outline">
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead class="thead-dark">
                                <tr>
                                    <th scope="col">Branch</th>
                                    <th scope="col">Receipts</th>
                                    <th scope="col">Sale Orders</th>
                                    <th scope="col">Invoices</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="branch in branches">
                                    <td>
                                        {{ branch.fullname }}
                                        <span
                                            class="badge badge-secondary"
                                            @click="
                                                viewSalespersonSales(branch)
                                            "
                                            ><i class="fa fa-search"></i
                                            >Salesperson</span
                                        >
                                        <span
                                            class="badge badge-primary"
                                            @click="viewDivisionSales(branch)"
                                            ><i class="fa fa-search"></i
                                            >Division</span
                                        >
                                        <span
                                            class="badge badge-warning"
                                            @click="viewBranchInvoices(branch)"
                                            ><i class="fa fa-search"></i
                                            >Invoices</span
                                        >
                                    </td>
                                    <td>
                                        {{
                                            branch.totalreceiptvalue
                                                | dotNumbers
                                        }}
                                        ({{ branch.totalreceiptcount }})
                                    </td>
                                    <td>
                                        {{
                                            branch.totalsaleordervalue
                                                | dotNumbers
                                        }}
                                        ({{ branch.totalsaleordercount }})
                                    </td>
                                    <td>
                                        {{
                                            branch.totalinvoicevalue
                                                | dotNumbers
                                        }}
                                        ({{ branch.totalinvoicecount }})
                                    </td>

                                    <!--                            <td>-->
                                    <!--                                &lt;!&ndash;									<button class="btn btn-danger" @click="view(order)" v-if="order.approved_by == null"">View</button>&ndash;&gt;-->
                                    <!--                                <button class="btn btn-primary" @click="edit(order)" v-if="order.approved_by == null"">Edit</button>-->
                                    <!--                                <button class="btn btn-success" v-if="order.approved_by != null"">REQUEST APPROVED</button>-->
                                    <!--                                <p v-if="order.approved_by != null">BY: {{order.approved_by.user_detail}}</p>-->
                                    <!--                            </td>-->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!--                <div class="card-footer">-->
                    <!--                    <pagination :pagination="pagination"-->
                    <!--                                @prev="getOrders(pagination.prevPageUrl)"-->
                    <!--                                @next="getOrders(pagination.nextPageUrl)"-->
                    <!--                    ></pagination>-->
                    <!--                </div>-->
                </div>
            </div>
        </section>
        <!-- /.content -->

        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getCompanies();
        this.getZones();
        this.getBranches();
        this.fromdate = new Date().toISOString().slice(0, 10);
        this.todate = new Date().toISOString().slice(0, 10);
        this.getStats();
    },

    data() {
        return {
            receipts: [],
            companies: [],
            branches: [],
            saleorders: [],
            invoices: [],
            company: "",
            branch: "",
            receipttotal: "Counting",
            saleordertotal: "Counting",
            invoicetotal: "Counting",
            saleordercount: "",
            invoicecount: "",
            receiptcount: "",
            fromdate: "",
            todate: "",
            zones: [],
            zone: "",
            zonename: "",
            zonecode: "",
        };
    },

    methods: {
        reset() {
            this.fromdate = "";
            this.todate = "";
            this.company = "";
            this.branch = "";
            this.getCompanies();
            this.getZones();
            this.getBranches();
            this.getStats();
        },
        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },

        getZones() {
            axios
                .post("/api/getZones", {
                    results: this.results,
                    name: this.zonename,
                    zone: this.zonecode,
                })
                .then((response) => {
                    this.zones = response.data;
                });
        },

        copyTable() {
            const table = document.querySelector(".table"); // Select the table element using its class
            const range = document.createRange();
            range.selectNode(table);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();
            alert("Table content copied to clipboard!");
        },

        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },
        getStats() {
            this.receipttotal = "";
            this.saleordertotal = "";
            this.invoicetotal = "";
            axios
                .post("/api/dailyBranchwiseSalesSummary", {
                    fromdate: this.fromdate,
                    todate: this.todate,
                    branch: this.branch,
                    zone: this.zone,
                    company: this.company,
                })
                .then((response) => {
                    this.branches = response.data.branches;
                    this.receiptcount = response.data.receipt_count;
                    this.receipttotal = response.data.receipt_value;
                    this.saleordercount = response.data.saleorder_count;
                    this.saleordertotal = response.data.saleorder_value;
                    this.invoicecount = response.data.invoice_count;
                    this.invoicetotal = response.data.invoice_value;
                });
        },
        viewSalespersonSales(branch) {
            if (this.fromdate != "") {
                this.$router.push(
                    "/reports/salespersonwise/daily-sales-value/" +
                        branch.branch_code +
                        "/" +
                        this.fromdate +
                        "/" +
                        this.todate
                );
            } else
                this.$router.push(
                    "/reports/salespersonwise/daily-sales-value/" +
                        branch.branch_code
                );
        },
        viewDivisionSales(branch) {
            if (this.fromdate != "") {
                this.$router.push(
                    "/reports/branchwise/daily-division-value/" +
                        branch.branch_code +
                        "/" +
                        this.fromdate +
                        "/" +
                        this.todate
                );
            } else
                this.$router.push(
                    "/reports/branchwise/daily-division-value/" +
                        branch.branch_code
                );
        },
        viewBranchInvoices(branch) {
            if (this.fromdate != "") {
                this.$router.push(
                    "/auditor/list-invoices/" +
                        branch.branch_code +
                        "/" +
                        this.fromdate +
                        "/" +
                        this.todate
                );
            } else
                this.$router.push(
                    "/auditor/list-invoices/" + branch.branch_code
                );

            // else if(time == 'month'){
            //     var date = new Date(), y = date.getFullYear(), m = date.getMonth();
            //     var firstDay = new Date(y, m, 1);
            //     var lastDay = new Date(y, m + 1, 0);
            //     this.$router.push({
            //         name: 'Job Report | Service Admin',
            //         params: {status:status, from:firstDay, to:lastDay, cat: cat}
            //     });
            // }
        },
    },
};
</script>
